import { readable } from "svelte/store";
import { getDistance } from 'geolib';
import { State } from "../Model/State";
import { isAndroid, isIOS } from "./platform";
const overridePosition = new State(undefined);
let hasPosition = false;
export function override(position) {
    hasPosition = true;
    overridePosition.set(position);
}
export function hasPlayerPosition() {
    return hasPosition;
}
export const playerPosition = readable(undefined, set => {
    let unsubNavigator;
    const unsubOverrided = overridePosition.subscribe(position => {
        if (position) {
            unsubNavigator === null || unsubNavigator === void 0 ? void 0 : unsubNavigator();
            unsubNavigator = undefined;
            set(position);
            return;
        }
        if (unsubNavigator) {
            return;
        }
        unsubNavigator = navigatorPosition.subscribe(position => {
            if (!position) {
                return;
            }
            set({
                lon: position.coords.longitude,
                lat: position.coords.latitude,
            });
        });
    });
    return () => {
        unsubNavigator === null || unsubNavigator === void 0 ? void 0 : unsubNavigator();
        unsubOverrided();
    };
});
export const isHighAccuracy = readable(false, set => {
    let unsubNavigator;
    const unsubOverrided = overridePosition.subscribe(position => {
        if (position) {
            unsubNavigator === null || unsubNavigator === void 0 ? void 0 : unsubNavigator();
            unsubNavigator = undefined;
            set(true);
            return;
        }
        if (unsubNavigator) {
            return;
        }
        unsubNavigator = navigatorPosition.subscribe(position => {
            if (!position) {
                return;
            }
            set(position.coords.accuracy < 200);
        });
    });
    return () => {
        unsubNavigator === null || unsubNavigator === void 0 ? void 0 : unsubNavigator();
        unsubOverrided();
    };
});
export function calcDistance(c1, c2) {
    return getDistance(c1, c2);
}
export function calcBearing({ lat: startLat, lon: startLng }, { lat: destLat, lon: destLng }) {
    startLat = toRadians(startLat);
    startLng = toRadians(startLng);
    destLat = toRadians(destLat);
    destLng = toRadians(destLng);
    const y = Math.sin(destLng - startLng) * Math.cos(destLat);
    const x = Math.cos(startLat) * Math.sin(destLat) - Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
    const brng = toDegrees(Math.atan2(y, x));
    return (brng + 360) % 360;
}
export const navigatorPosition = readable(undefined, set => {
    const watchId = window.navigator.geolocation.watchPosition(position => {
        hasPosition = true;
        set(position);
    }, error => console.error(error), {
        enableHighAccuracy: true
    });
    return () => window.navigator.geolocation.clearWatch(watchId);
});
// Converts from degrees to radians.
function toRadians(degrees) {
    return degrees * Math.PI / 180;
}
;
// Converts from radians to degrees.
function toDegrees(radians) {
    return radians * 180 / Math.PI;
}
export function getPlatformGeolocationSettingsLink() {
    if (isAndroid) {
        return 'https://support.google.com/accounts/answer/3467281?hl=es';
    }
    if (isIOS) {
        return 'https://support.apple.com/es-lamr/HT207092#:~:text=Ve%20a%20Configuraci%C3%B3n%20%3E%20Privacidad%20y,desactiva%20la%20opci%C3%B3n%20Ubicaci%C3%B3n%20precisa';
    }
    return undefined;
}
